export default __webpack_public_path__ + "static/media/19.18d0cb9c.png";